import { useI18n } from '../../i18n';

export default function PrivacyPolicy() {
	const { t } = useI18n();

	return (
		<div className="container py-5" style={{ maxWidth: 720 }}>
			<h1 className="h3 mb-3">
				{t('privacy.title', 'Privacy Policy')}
			</h1>
			<p className="text-muted small mb-4">
				{t('privacy.updated', 'Last updated: October 2026')}
			</p>

			<p>
				{t(
					'privacy.intro',
					'HortEra (operated in connection with Agilos IT) processes limited personal data to run the garden planning platform, keep accounts secure, and understand how the product is used.'
				)}
			</p>

			<h2 className="h5 mt-4">
				{t('privacy.account.title', 'Account data')}
			</h2>
			<p>
				{t(
					'privacy.account.body',
					'When you register or use the app, we store information you provide such as name, email, role, optional profile details, and garden plan content (including locations you enter for plans).'
				)}
			</p>

			<h2 className="h5 mt-4">
				{t('privacy.analytics.title', 'Analytics, IP address, and country')}
			</h2>
			<p>
				{t(
					'privacy.analytics.body',
					'To operate and improve HortEra, we record product analytics (for example page views and feature usage). As part of that, we may store your IP address and a derived country code for security, abuse prevention, and aggregated geographic analytics. We do not sell this data. Country may also appear in tools such as Google Analytics when that service is enabled.'
				)}
			</p>

			<h2 className="h5 mt-4">
				{t('privacy.cookies.title', 'Cookies and similar tech')}
			</h2>
			<p>
				{t(
					'privacy.cookies.body',
					'We use cookies or local storage for login/session state and basic analytics identifiers. You can clear these in your browser settings.'
				)}
			</p>

			<h2 className="h5 mt-4">
				{t('privacy.rights.title', 'Your rights')}
			</h2>
			<p>
				{t(
					'privacy.rights.body',
					'Depending on where you live, you may have rights to access, correct, or delete personal data. Contact us via the details on hortera.org / Agilos IT if you want to make a request.'
				)}
			</p>
		</div>
	);
}
